import athenaConfig from '../config';

export function launchedFromLwaProfile() {
  const { manageFactorValue, clientIdParam } = lwaProfileLaunchedParams();
  return !!(
    manageFactorValue === 'true' &&
    clientIdParam &&
    athenaConfig?.manageProfileClientSettings?.[clientIdParam]
  );
}

export function lwaProfileLaunchedParams() {
  const queryParams = new URLSearchParams(window.location.search);
  const manageFactorValue = queryParams.get('manageFactor');
  const clientIdParam = queryParams.get('clientId');
  const lwaProfileUrl = athenaConfig?.manageProfileClientSettings?.[clientIdParam!]?.manageFactorUrl;
  return { manageFactorValue, clientIdParam, lwaProfileUrl };
}
